import { Control, Icon, Input, Level, LevelItem, bulma } from "trunx";
import { faBars, faSearch } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ISensor } from "./models/Sensors";
import L from "leaflet";
import NavMenu from "./NavMenu";
import { createPortal } from "react-dom";
import { observer } from "mobx-react-lite";
import useFindSensors from "./hooks/useFindSensor";
import { useLocaleContext } from "./contexts/LocaleContext";
import { useRootStore } from "./models/Root";

const MobileNavInner = observer(() => {
  const {
    dict: {
      nav: dict,
      panel: {
        find: { precip, stream },
      },
    },
  } = useLocaleContext();

  const {
    menus: { toggleNav, nav, closeNav },
    sensors: { setSensor },
  } = useRootStore();

  const [find, setFind] = useState<string>("");
  useEffect(() => {
    if (nav) {
      setFind("");
    }
  }, [nav]);

  useEffect(() => {
    if (find !== "") {
      closeNav();
    }
  }, [closeNav, find]);

  const findResults = useFindSensors(find);

  const findRow = (result: Fuzzysort.KeyResult<ISensor>) => {
    const sensor = result.obj;
    const { name, type } = sensor;

    const onClick = () => {
      setSensor(sensor);
      setFind("");
    };
    return (
      <li key={sensor.id} onClick={onClick}>
        {name}
        <br />
        {type === "precip" ? precip : stream}
      </li>
    );
  };

  return (
    <div
      className={
        bulma(["is-hidden-desktop", "has-background-dark"]) +
        " mobile-nav leaflet-control"
      }
    >
      <Level>
        <LevelItem
          onClick={toggleNav}
          className="is-narrow"
          style={{ backgroundColor: "transparent" }}
        >
          <Icon>
            <FontAwesomeIcon icon={faBars} />
          </Icon>
        </LevelItem>
        <LevelItem>
          <Control hasIconsRight>
            <Input
              id="find"
              className={bulma("has-background-dark")}
              placeholder={dict.search}
              onChange={(e) => setFind(e.target.value)}
              value={find}
              type="search"
              autoComplete="off"
            ></Input>
            <Icon className={"is-right"}>
              <FontAwesomeIcon icon={faSearch} />
            </Icon>
          </Control>
        </LevelItem>
      </Level>
      {nav && <NavMenu />}
      {findResults && <ul> {findResults.map(findRow)}</ul>}
    </div>
  );
});

const findContainer = () => {
  const root = document.querySelector(".leaflet-top.leaflet-left");
  if (root === null) {
    return undefined;
  }

  const container = root?.querySelector(".mobile-nav-container");
  if (container !== null) {
    return container;
  } else {
    const container = document.createElement("div");
    container.className = "leaflet-bar mobile-nav-container";
    L.DomEvent.disableClickPropagation(container);
    L.DomEvent.disableScrollPropagation(container);
    L.DomEvent.on(container, "click", L.DomEvent.stopPropagation);
    L.DomEvent.on(container, "scroll", L.DomEvent.stopPropagation);
    root.prepend(container);
    return container;
  }
};

const MobileNav = () => {
  const container = findContainer();
  return container ? createPortal(<MobileNavInner />, container) : null;
};

export default MobileNav;
